import React from "react";
import { Box, Typography } from "@bca/ui-library";

import VehicleNotFoundSVG from "./Icons/VehicleNotFoundSVG";

const VehicleNotFound = () => (
  <Box
    width="100%"
    height={400}
    display="flex"
    alignItems="center"
    justifyContent="center"
    flexDirection="column"
  >
    <VehicleNotFoundSVG width={48} height={48} />
    <Typography variant="h4" my={3}>
      Lot not found
    </Typography>
    <Typography
      variant="body"
      color="grey-blue"
      textAlign="center"
      m={0}
      css={`
        max-width: 250px;
      `}
    >
      Sorry, we were unable to find the lot you were looking for.
    </Typography>
  </Box>
);

export default VehicleNotFound;
